module.exports = __webpack_public_path__ + "media/puzzle1_1.5658c625.mp3";